import { postJSON } from 'common/services/api'
import {
  REVISIONS_QUERY_KEY,
  REVISION_CANCEL_QUERY_KEY,
  REVISION_CANCEL_URL,
  REVISION_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseRevisionCancelReturn = {
  cancelRevision?: (values: CancelRevisionPayload) => Promise<unknown>
  isCancelRevisionLoading?: boolean
}

type UseRevisionCancelProps = {
  id?: string
}

export type CancelRevisionPayload = {
  reason: string
  notes: string
}

type CancelRevisionResponse = any

const useRevisionCancel = ({
  id,
}: UseRevisionCancelProps): UseRevisionCancelReturn => {
  const queryClient = useQueryClient()

  // Cancel event
  const cancelFunction = async (
    values: CancelRevisionPayload
  ): Promise<CancelRevisionResponse> => {
    return postJSON({
      url: `${REVISION_CANCEL_URL}/${id}`,
      method: 'POST',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: cancelMutation, isLoading: isCancelRevisionLoading } =
    useMutation<
      CancelRevisionResponse,
      unknown,
      CancelRevisionPayload,
      unknown
    >([REVISION_CANCEL_QUERY_KEY], cancelFunction, {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
        queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
      },
    })

  const handleCancel = async (values: any) => {
    try {
      const result = await cancelMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    cancelRevision: handleCancel,
    isCancelRevisionLoading,
  }
}

export default useRevisionCancel
